export const testimonials = [
  {
    id: 'test-1',
    name: '張先生',
    age: 42,
    occupation: '企業高管',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20portrait%2C%20warm%20smile%2C%20business%20casual%2C%20clean%20white%20background%2C%20headshot%20photography&width=200&height=200&seq=xfb-avatar-1&orientation=squarish',
    content: '工作壓力大，經常加班到深夜，感覺身體越來越吃不消。朋友推薦了性福寶，用了大概兩個月左右，明顯感覺精力比以前充沛了，和太太的關係也變得更加和諧。現在已經成了我們家的常備品。',
    usageDuration: '使用 3 個月',
  },
  {
    id: 'test-2',
    name: '李先生',
    age: 35,
    occupation: '健身教練',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Fitness%20trainer%20Asian%20male%20portrait%2C%20confident%20expression%2C%20athletic%20build%2C%20clean%20background%2C%20headshot%20photography&width=200&height=200&seq=xfb-avatar-2&orientation=squarish',
    content: '身為健身教練，我對保健品的要求很高。性福寶的成分表很乾淨，都是天然草本萃取，沒有亂七八糟的添加劑。用了之後訓練恢復更快，整體狀態也上了一個台階。',
    usageDuration: '使用 2 個月',
  },
  {
    id: 'test-3',
    name: '王先生',
    age: 50,
    occupation: '退休教師',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20male%20portrait%2C%20kind%20smile%2C%20casual%20attire%2C%20clean%20white%20background%2C%20headshot%20photography&width=200&height=200&seq=xfb-avatar-3&orientation=squarish',
    content: '年紀大了，身體各方面機能都在下降。兒子給我買了性福寶，剛開始還有點懷疑，用了三個月後，不得不說效果確實不錯。現在精神頭比以前好多了，和老伴出去旅遊也不容易累了。',
    usageDuration: '使用 6 個月',
  },
  {
    id: 'test-4',
    name: '趙先生',
    age: 28,
    occupation: '程序員',
    rating: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%2C%20friendly%20expression%2C%20modern%20casual%20style%2C%20clean%20background%2C%20headshot%20photography&width=200&height=200&seq=xfb-avatar-4&orientation=squarish',
    content: '長期久坐加上熬夜，身體處於亞健康狀態。用了性福寶大概一個半月，感覺最明顯的變化就是不再那麼容易疲勞了，工作效率也提高了不少。會繼續回購。',
    usageDuration: '使用 1.5 個月',
  },
  {
    id: 'test-5',
    name: '劉先生夫婦',
    age: 36,
    occupation: '自由職業者',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Happy%20Asian%20couple%20portrait%2C%20warm%20smiles%2C%20casual%20elegant%20attire%2C%20clean%20background%2C%20couple%20headshot%20photography&width=200&height=200&seq=xfb-avatar-5&orientation=squarish',
    content: '買了伴侶套裝，和太太一起用。效果真的超出了預期，不僅身體狀態變好了，兩個人的關係也變得更加親密。準備再買一套蜜月禮盒送給朋友當結婚禮物。',
    usageDuration: '使用 2 個月',
  },
  {
    id: 'test-6',
    name: '陳先生',
    age: 45,
    occupation: '銷售經理',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Asian%20male%20portrait%2C%20professional%20and%20approachable%2C%20business%20attire%2C%20clean%20background%2C%20headshot%20photography&width=200&height=200&seq=xfb-avatar-6&orientation=squarish',
    content: '銷售工作應酬多，身體長期處於透支狀態。用性福寶尊享版兩個多月，精力明顯回來了，應酬也不再像以前那麼吃力。同事都問我最近是不是換了什麼養生方法。',
    usageDuration: '使用 2.5 個月',
  },
];